import type { DeepPartial } from '@luna/utils-ts';

import { chartsCZFeatureConfig } from './charts/CZ';
import { dashboardCZFeatureConfig } from './dashboard/CZ';
import { documentsCZFeatureConfig } from './documents/CZ';
import { miscCZFeatureConfig } from './misc/CZ';
import { ordersCZFeatureConfig } from './orders/CZ';
import { overviewCZFeatureConfig } from './overview/CZ';
import { pipCZFeatureConfig } from './pip/CZ';
import { printCZFeatureConfig } from './print/CZ';
import { productSettingsCZFeatureConfig } from './productSettings/CZ';
import { profileCZFeatureConfig } from './profile/CZ';
import { regularOrdersCZFeatureConfig } from './regularOrders/CZ';
import { searchCZFeatureConfig } from './search/CZ';
import { statementsCZFeatureConfig } from './statements/CZ';
import { titleDetailCZConfig } from './titleDetail/CZ';
import { tradingConfigCZ } from './trading/CZ';
import type { InvestmentsFeatureConfig } from '../types/InvestmentsFeatureConfig';

export const investments: DeepPartial<InvestmentsFeatureConfig> = {
    charts: chartsCZFeatureConfig,
    dashboard: dashboardCZFeatureConfig,
    documents: documentsCZFeatureConfig,
    misc: miscCZFeatureConfig,
    orders: ordersCZFeatureConfig,
    overview: overviewCZFeatureConfig,
    pip: pipCZFeatureConfig,
    print: printCZFeatureConfig,
    productSettings: productSettingsCZFeatureConfig,
    profile: profileCZFeatureConfig,
    regularOrders: regularOrdersCZFeatureConfig,
    search: searchCZFeatureConfig,
    statements: statementsCZFeatureConfig,
    titleDetail: titleDetailCZConfig,
    trading: tradingConfigCZ,
};
